import React from 'react'

function Iframe({ source }) {
  return (
    <iframe
      src={source}
      width="100%"
      style={{
        border: 'none',
        minHeight: '800px',
        height: '100vh' // or use a specific height like '800px'
      }}
    ></iframe>
  )
}

export default Iframe
